import { TitleRowTabBeneficiaries } from 'components/TitleRowTabBeneficiaries';
import { OrdersEmployedsItem } from 'ui/OrdersEmployedsItem';
import { useGetTabEmployedsQuery } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { Nothing } from 'components/Nothing';
import styles from './Orders.module.scss';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import {
  QueryParamsTabEmployedsType,
  ResponseTabEmployedsOrdersType,
} from 'redux/Api/employedsWorkSupportApi/type';

export const Orders = ({ id = 0, title }: QueryParamsTabEmployedsType) => {
  const { data, isLoading, error } = useGetTabEmployedsQuery({ id, title });

  const dataOrders = [
    'Дата начала',
    'Тип услуги',
    'Сумма',
    'Оплата',
    'Выплата',
    'Статус',
  ];

  return (
    <div className={styles.root}>
      <TitleRowTabBeneficiaries data={dataOrders} title='ordersEmployeds' />
      {error || !data?.length ? (
        <Nothing
          style={{ height: '640px' }}
          title={error ? 'Ошибка, попробуйте позже' : 'Ничего не найдено'}
        />
      ) : isLoading ? (
        <LoadingSkeleton tabDetails />
      ) : (
        (data as ResponseTabEmployedsOrdersType[])?.map((elem, i) => (
          <OrdersEmployedsItem order={elem} key={i} />
        ))
      )}
    </div>
  );
};
